define('models/calendar/session',[
    'underscore', 'backbone', 'moment', 'utils', 'debug',
    // src
    'services/api',
    'services/session',
    // events
    'services/events/animated-session-events',
    // collections
    'collections/calendar/session/exercise/exercises',
    'collections/calendar/items'
], function(
    _, Backbone, moment, U, DEBUG, API, Session,
    // events
    AnimationEvents,
    // collections
    CExercises,
    CCalendarItems
) {
    var MAX_WEEK = 16;

    var MSession = Backbone.Model.extend({
        idAttribute: '_id',
        // maxWeek: 16,
        urlRoot: API.url('animated-sessions/'),
        blacklist: [
            '_calendarChanges', // read-only, exist only after an update
            '_autoAdjustCalendar', // patch/update flag
            '_calendar',
            'next',
            'oldCid',
        ],
        defaults: function() {
            return {
                name: "",
                notes: "",
                num_weeks: 4,
                exercises: [],
                _date: API.formatDate(moment()),
            };
        },

        initialize: function(attrs, options) {
            this.options = _.extend({
                calendar: 'full',
            }, options);
        },

        sync: function(method, model, options) {

            if (method === 'update' || method === 'patch') {
                options.attrs = _.extend({}, options.attrs, {
                    _autoAdjustCalendar: true
                });
            }

            return MSession.__super__.sync.call(this, method, model, options);
        },

        fetch: function(options) {
            var calendar = this.options.calendar;
            options = _.extend({
                calendar: calendar
            }, options);

            if (options.calendar) {
                options.data = _.extend({
                    calendar: calendar
                }, options.data);
            }

            return MSession.__super__.fetch.call(this, options);
        },

        resetToNew: function(user, momentDate, options) {
            return this.reset({
                user: user,
                _date: API.formatDate(momentDate)
            }, options);
        },

        resetToId: function(id, user, options) {
            var attrs = { user: user };
            attrs[this.idAttribute] = id;
            return this.reset(attrs, options);
        },

        getFavoriteData: function() {
            return _.extend({
                exercises: this.getExerciseCollection().toJSON({ blacklist: true })
            }, _.pick(this.attributes, ['name', 'notes', 'num_weeks']));
        },

        getExerciseCollection: function() {
            if (!this.exerciseCollection) {
                this.exerciseCollection = new CExercises(this.getExercises());
                this.exerciseCollection.sessionId = this.id;
            }

            return this.exerciseCollection;
        },

        resetExerciseCollection: function() {
            var collection = this.exerciseCollection;
            if (collection) {
                collection.reset(this.getExercises());
                collection.sessionId = this.id;
            }
            return this;
        },

        ///////////////
        // accessors //
        ///////////////
        hasReceivedChanges: function() {
            return this.has('_calendarChanges');
        },

        getReceivedChanges: function() {
            return this.get('_calendarChanges');
        },

        /**
         * Set the date using a moment date and a model specific format.
         */
        setDate: function(momentDate, options) {
            return this.set('_date', API.formatDate(momentDate), options);
        },

        getDate: function() {
            return this.get('_date');
        },

        getExercises: function() {
            return this.get('exercises').filter(function(m) { return m.type !== "placeholder"; });
        },

        hasExercises: function() {
            return this.has('exercises') && this.getExercises().length > 0;
        },

        setExercises: function(models) {
            return this.set({
                exercises: models
            });
        },

        getNotes: function() {
            return this.get('notes');
        },

        getWeekCount: function() {
            return this.get('num_weeks');
        },

        getName: function() {
            return this.get('name');
        },

        getItemByWeek: function(weekIndex) {
            return this.getItems().findWhere({ week: weekIndex });
        },

        getItems: function() {
            return new CCalendarItems(this.get('_calendar'));
        },

        fetchHistory: function(userID, exerciseId) {
            Backbone.ajax({
                url: API.url("animated-sessions/getHistory?userID=") + userID + "&exerciseID=" + exerciseId + "&date=" + this.getDate(),
                method: "GET",
                dataType: "json",
                contentType: "application/json",

                success: function(response, textStatus, xhr) {
                    var history = {};
                    var sess = null;
                    var calendarHistory = new CCalendarItems(response.calendarHistory);
                    var sessionHistory = new CCalendarItems(response.sessionHistory);

                    _.each(calendarHistory.models.reverse(), function(cEntry) {
                        //For the preceding calendar entry, we must find the corresponding session
                        for (var j = 0; j < sessionHistory.models.length; j++) {
                            sess = sessionHistory.models[j];
                            //if the session match and the calendar entry is not already in the array, we find the week
                            if (cEntry.get("session") === sess.get("_id") && _.isUndefined(history[cEntry.get("date")])) {
                                for (var i = 0; i < sess.get("exercises").length; i++) {
                                    var exercise = sess.get("exercises")[i];
                                    //when a match exist
                                    if (exercise.type === 'weight' && exercise.animatedExercise === exerciseId) {
                                        history[cEntry.get("date")] = exercise.weeks[cEntry.get("week")];
                                        break;
                                    }
                                }
                            }
                        }
                    }, this);

                    AnimationEvents.historyLoaded(history);
                },
            });
        },

        ////////////////
        // validation //
        ////////////////
        validation: {
            name: {
                presence: true,
            },
            num_weeks: {
                presence: true,
                numericality: {
                    onlyInteger: true,
                    greaterThanOrEqualTo: 1,
                    lessThanOrEqualTo: MAX_WEEK,
                    message: "The number of weeks must be between the specified range.",
                },
            },
            _date: {
                datetime: true,
            },

        },

    }, {
        /////////////////////
        // classProperties //
        /////////////////////
        maxWeek: MAX_WEEK,

    });

    return MSession;
});

